// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__9A1O6","startButton":"Tabs_startButton__JY7QU","feeContainer":"Tabs_feeContainer__a96f7"};